import { render } from "./PerformanceHit.vue?vue&type=template&id=7f4bd62e"
import script from "./PerformanceHit.vue?vue&type=script&lang=js"
export * from "./PerformanceHit.vue?vue&type=script&lang=js"

import exportComponent from "/app/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__